// src/components/forms/formSteps/LastNameStep.tsx
import React from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";

interface LastNameStepProps {
  lastName: string;
  validation: { valid: boolean; error: string };
  onChange: (field: string, value: string) => void;
  onSubmit: () => void; // Added explicit submit handler
  isMobile: boolean;
}

const LastNameStep: React.FC<LastNameStepProps> = ({
  lastName,
  validation,
  onChange,
  onSubmit,
  isMobile,
}) => {
  // Handle keydown event - only prevent default
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };
  const { t } = useTranslation();

  return (
    <>
      <Typography
        variant={isMobile ? "subtitle1" : "h6"}
        align="center"
        sx={{ color: "#c6c6c6", mb: 2 }}
      >
        {t("form.sixthQuestion.title")}
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        7. {t("form.seventhQuestion.question")}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <TextField
        fullWidth
        placeholder="Enter your last name"
        value={lastName}
        onChange={(e) => {
          const newValue = e.target.value;
          onChange("lastName", newValue);
        }}
        onKeyDown={handleKeyDown}
        error={!validation.valid}
        helperText={validation.error || `${lastName.length}/63 characters`}
        sx={{ mb: 2 }}
      />

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          size="large"
          onClick={onSubmit}
          disabled={lastName.trim() === "" || !validation.valid}
          sx={{
            minWidth: "200px",
            py: 1.5,
            fontWeight: "bold",
            backgroundColor: "#ff6b35",
            "&:hover": {
              backgroundColor: "#e25a2a",
            },
          }}
        >
          Continue
        </Button>
      </Box>
    </>
  );
};

export default LastNameStep;
